// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-ef185ce6]{text-align:center}.content .password-box[data-v-ef185ce6]{min-height:10.416667rem}", ""]);
// Exports
module.exports = exports;
